import { render } from "./AssignAttributesFromIntegrationModal.vue?vue&type=template&id=89c55a32"
import script from "./AssignAttributesFromIntegrationModal.vue?vue&type=script&lang=js"
export * from "./AssignAttributesFromIntegrationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__